/** TanStack may parse bare numeric query parameters as numbers. */
export function contractSearch(search: Record<string, unknown>): { block?: string; tab?: string; tx?: string; depth?: string } {
  let block: string | undefined;
  if (search.block !== undefined && search.block !== null && search.block !== "") {
    if (typeof search.block === "number" && Number.isSafeInteger(search.block) && search.block >= 0) block = String(search.block);
    else if (typeof search.block === "string" && /^\d+$/.test(search.block)) block = search.block;
    else throw new Error("Invalid block height. Use a non-negative whole number; quote large heights in the URL to preserve precision.");
  }
  return {
    block,
    tab: typeof search.tab === "string" ? search.tab : undefined,
    depth: typeof search.depth === "number" && Number.isInteger(search.depth) ? String(search.depth) : typeof search.depth === "string" ? search.depth : undefined,
    tx: typeof search.tx === "string" && /^0x[0-9a-fA-F]{64}$/.test(search.tx) ? search.tx : undefined,
  };
}
